<!--Copy right - © 2024 tecera gmbh-->
<script>
    import LoginForm from "../components/forms/LoginForm.svelte";
</script>

<svelte:head>
    <title>Mapview - Login</title>
</svelte:head>

<div class="background-container">
    <LoginForm />
</div>
